





































import {Component, Prop, Vue} from 'vue-property-decorator';
import VeneerSubcomponent from './EquipmentTypeVeneerProcessGroup.vue';
import PlywoodSubcomponent from './EquipmentTypePlywoodCmpl.vue';
import equipmentCategoryConfig from '@/enums/EquipmentCategoryEnum';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
@Component({
    components: {CFlexGrid},
})
export default class EquipmentType extends Vue {
    @Prop() tabData!: any;
    @Prop() params!: any;

    private veneerSubcomponent = VeneerSubcomponent;
    private plywoodSubcomponent = PlywoodSubcomponent;
    private config = equipmentCategoryConfig;
    private equipmentCategory: number | null = null;

    get idPlanRes() {
        return this.tabData?.idPlanRes;
    }

    get shiftIndex() {
        let value = this.params?.requestParams?.find((item: any) => item.key === 'shiftIndex')?.value;
        return value !== undefined && value !== -1 ? value : this.tabData?.shiftIndex;
    }

    get idEquipmentType() {
        let value = this.params?.requestParams?.find((item: any) => item.key === 'idEquipmentType')?.value;
        return value !== undefined && value !== -1 ? value : this.tabData?.idEquipmentType;
    }

    created() {
        this.getEquipmentCategory();
    }

    async getEquipmentCategory() {
        try {
            const {data} = await this.$http.get(`${this.$api.catalogues.equipmentType}/GetView`, {
                params: {
                    id: this.idEquipmentType,
                },
            });
            this.equipmentCategory = data.IdEquipmentCategory;
        } catch {}
    }
}
